<template>
  <v-select
    label="Item"
    class="white"
    :items="data"
    item-value="id"
    v-model="inputVal"
    return-object
  >
    <template v-slot:item="slotProps">
      <div class="d-flex align-center">
        <v-img
          :src="slotProps.item.imageUrl"
          max-width="40"
          max-height="40"
          class="mr-2"
          contain
        ></v-img>
        <div>
          <div>{{ slotProps.item.name }}</div>
          <small v-if="slotProps.item.price" class="grey--text d-flex">{{ slotProps.item.price }}  <v-img
          :src="slotProps.item.Currency.imageUrl"
          max-width="15"
          max-height="15"
          class="ml-1"
          contain
        ></v-img></small>
        <small v-else class="grey--text">Free</small>
        </div>
      </div>
    </template>

    <template v-slot:selection="slotProps">
      <div class="d-flex align-center">
        <v-img
          :src="slotProps.item.imageUrl"
          max-width="30"
          max-height="30"
          class="mr-2"
          contain
        ></v-img>
        <div>
          {{ slotProps.item.name }}
        </div>
          <small v-if="slotProps.item.price" class="grey--text d-flex ml-1">({{ slotProps.item.price }}  <v-img
          :src="slotProps.item.Currency.imageUrl"
          max-width="15"
          max-height="15"
          class="ml-1"
          contain
        ></v-img>)</small>
        <small v-else class="grey--text ml-1">(Free)</small>
      </div>
    </template>
  </v-select>
</template>


<script>
import { mapState } from "vuex";
export default {
  props: ["callbackSelect", "callbackError","value"],
  data: () => ({
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    data: [],
    id: null,
    item: null,
  }),
  created() {
    //BOC:[api]
    this.api.method = "get";
    this.api.url =`${this.$api.servers.game}/api/v1/en/data/item`
    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
    };
    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
      //BOC:[parent]
      this.callbackError(e);
      //EOC
    };
    this.api.callbackSuccess = (resp) => {
      this.api.isLoading = false;
      this.data = resp;
      this.item = resp[0];
      this.value = resp[0].id
      this.$emit("input", this.value);
    };
    //EOC
  },
   computed: {
    ...mapState({
      school: (state) => state.school.data,
    }),
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val.id);
      },
    },
  },
  methods: {
    fetch() {
      this.$api.fetch(this.api);
    },
  },
  mounted() {
    this.$api.fetch(this.api);
  },
};
</script>
